import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const quotationrow = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/quotation/{profile}/quotation-row',
    app: 'quotation'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'quotation', model: 'quotationrow' }
    ),
    { }
  )
)()

export { quotationrow, TYPES }
